import React from 'react'
import { NavLink, Link ,useNavigate} from 'react-router-dom'






function Header() {


const navigate=useNavigate()

  const handleLogin = () => {


    localStorage.removeItem('token');
    localStorage.removeItem('userId');

    navigate('/login')
}



  return (
    <div>
      <nav id='dil' className="navbar navbar-expand-lg navbar-light ">
        <div className="container-fluid">
          <Link className="navbar-brand" to='/'><i id='tit'>Work_Memo</i></Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav">
              


              {
                localStorage.getItem("token") ? <div className='navbar-nav'>
                 
                <li className="nav-item">
                <Link onClick={handleLogin} className="nav-link active " id='xxx' aria-current="page"  >LogOut</Link>
              </li>

                  <li className="nav-item">
                    <Link className="nav-link active" id='x' to='/create' >UseMemo</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active " id='x' to='/body'>Record</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link active " id='x' to='/update'>All_Records</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link active " id='x' to='/about'>About</Link>
                  </li>

                </div>
                  :
                  <li className="nav-item">
                    <Link className="nav-link active" id='xx' to='/login' >Login</Link>
                  </li>
              }

            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Header
